import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import Link from 'components/Link'

import { PictureContainer, PictureIcons, GiphyAttribute, StyledImage } from './styles'

const Picture = ({ className = '', withZoom = false, url, link = '', legend, legendSize = null, title, alt = '', inModal = false, isGiphy, newTab, hideLinkIcon= false, fullSizeGif, onClick = null, onPointerDown = null }) => {
  const [disableZoom, setDisableZoom] = useState(true)
  const [disablePan, setDisablePan] = useState(true)

  const hasLink = link && link.length > 0

  const handleTransformStart = (ref, e) => {
    if (ref.scale > 1) {
      setDisablePan(false)
    } else {
      setDisablePan(true)
    }
    setDisableZoom(false)
  }

  return (
    <PictureContainer $disable={disableZoom} $inModal={inModal}>
      {title && (
        <h2
          style={{
            margin: '0 0 10px 10px',
            fontSize: '24px',
            fontWeight: '600',
            color: '#333',
            alignSelf: 'center',
          }}
        >
          {title}
        </h2>
      )}
      {withZoom && (
        <TransformWrapper
          pan={{ disabled: disablePan }}
          onPanningStart={handleTransformStart}
          onPinchingStart={handleTransformStart}
          onWheelStart={handleTransformStart}
          onZoomChange={handleTransformStart}
        >
          <TransformComponent>
            <img className={className} src={url} alt={alt} />
          </TransformComponent>
        </TransformWrapper>
      )}

      {hasLink && !withZoom && (
        <a
          id="image link"
          data-ga="link img"
          href={link}
          target={newTab ? '_blank' : ''}
          style={{ width: fullSizeGif || fullSizeGif === undefined ? 'auto' : '100%' }}
        >
          <StyledImage src={url} alt={alt} fullSizeGif={fullSizeGif} />
        </a>
      )}

      {!hasLink && !withZoom && (
        <StyledImage
          className={className}
          src={url}
          alt={alt}
          fullSizeGif={fullSizeGif}
          onClick={onClick}
          onPointerDown={onPointerDown}
          style={onClick ? { cursor: 'zoom-in' } : undefined}
        />
      )}

      <PictureIcons>
        {hasLink && !hideLinkIcon && (
          <Link id="image link" dataGa="link img" href={link} target={newTab ? '_blank' : ''}>
            <img src="/static/svg/icon/link.svg" alt={"link icon"} />
          </Link>
        )}

        {withZoom && <img src="/static/svg/icon/zoom.svg" alt={"zoom icon"} />}
      </PictureIcons>

      {isGiphy && <GiphyAttribute className={className} src="/static/logos/PoweredBy_Horizontal_Light.png" />}

      {legend && legend.length > 0 && <legend style={{fontSize: legendSize ? legendSize === 'small' ? "13px" : "16px" : '13px'}}>{legend}</legend>}
    </PictureContainer>
  )
}

Picture.propTypes = {
  alt: PropTypes.string,
  inModal: PropTypes.bool,
  isGiphy: PropTypes.bool,
  legend: PropTypes.any,
  link: PropTypes.string,
  newTan: PropTypes.bool,
  url: PropTypes.string,
  withZoom: PropTypes.bool,
  hideLinkIcon: PropTypes.bool,
  onClick: PropTypes.func,
  onPointerDown: PropTypes.func,
}

export default Picture
